import React, { useState } from 'react'
import {
  Typography,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Input,
  InputAdornment,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import CrossMarkIcon from 'Assets/Images/icons/crossMark'
import {
  isPlaceholderKeyDeepLink,
  PLACEHOLDER_KEYS,
  PLACEHOLDER_LABELS,
} from 'shared/constants'

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    '&:before': {
      height: 0,
    },
    '&&': {
      margin: 0,
    },
  },
  crossMarkIcon: {
    cursor: 'pointer',
  },
  label: {
    color: '#798498',
    fontSize: 12,
    height: 28,
    overflowX: 'auto',
    padding: 5,
  },
  input: {
    border: '1px solid rgba(39, 55, 84, 0.12)',
    borderRadius: 4,
    fontSize: 12,
    height: 28,
    padding: 5,
    width: '100%',
  },
  summary: {
    justifyContent: 'flex-start',
    padding: 0,
    '& div': {
      flexGrow: 0,
    },
    '& p': {
      color: '#00112B',
      fontSize: 12,
    },
    '&.Mui-expanded': {
      minHeight: 0,
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
  },
  details: {
    padding: 0,
    '& > div': {
      margin: 0,
      maxHeight: 150,
      overflowY: 'auto',
    },
  },
}))

const PlaceholderEditor = ({
  placeholders,
  defaultDynamicValues = {},
  customDynamicValues = {},
  onClearInput,
  onChangeInput,
}) => {
  const [accordionExpanded, setAccordionExpanded] = useState(false)

  const classes = useStyles()

  const filteredPlaceholders = [...new Set(placeholders)]

  const renderAccordion = (filteredPlaceholders || []).some(
    placeholder => !isPlaceholderKeyDeepLink(PLACEHOLDER_KEYS[placeholder]),
  )

  if (!renderAccordion) {
    return null
  }

  return (
    <Accordion
      className={classes.root}
      expanded={accordionExpanded}
      onChange={() => setAccordionExpanded(!accordionExpanded)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.summary}
      >
        <Typography className={classes.heading}>
          Alternative placeholders
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Grid container spacing={1}>
          {filteredPlaceholders.map((p, index) => {
            const key = PLACEHOLDER_KEYS[p]
            if (isPlaceholderKeyDeepLink(key)) {
              return null
            }
            return (
              <Grid key={`${p}${index}`} container item xs={12}>
                <Grid item xs={5}>
                  <div className={classes.label}>{PLACEHOLDER_LABELS[key]}</div>
                </Grid>
                <Grid item xs={7}>
                  <Input
                    className={classes.input}
                    endAdornment={
                      <InputAdornment position="end">
                        <CrossMarkIcon
                          className={classes.crossMarkIcon}
                          onClick={() => onClearInput(p)}
                        />
                      </InputAdornment>
                    }
                    onChange={onChangeInput}
                    name={p}
                    value={customDynamicValues[p] || ''}
                    placeholder={defaultDynamicValues[key]}
                    disableUnderline={true}
                  />
                </Grid>
              </Grid>
            )
          })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default PlaceholderEditor
